/**
 * Detect platform and return embed iframe URL (or null) for a public post URL.
 */
export function getEmbedInfo(url) {
  if (!url) return null;
  const u = url.trim();

  // TikTok: https://www.tiktok.com/@user/video/1234567890
  let m = u.match(/tiktok\.com\/(?:@[\w.-]+\/video|v)\/(\d+)/);
  if (m) {
    return { platform: "tiktok", embedUrl: `https://www.tiktok.com/embed/v2/${m[1]}`, aspect: "9/16" };
  }

  // Instagram post / reel / tv
  m = u.match(/instagram\.com\/(?:p|reel|tv)\/([A-Za-z0-9_-]+)/);
  if (m) {
    return { platform: "instagram", embedUrl: `https://www.instagram.com/p/${m[1]}/embed`, aspect: "1/1" };
  }

  // YouTube watch / shorts / youtu.be
  m = u.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]+)/);
  if (m) {
    return { platform: "youtube", embedUrl: `https://www.youtube.com/embed/${m[1]}`, aspect: "16/9" };
  }

  return null;
}

export const PLATFORM_LABEL = { instagram: "Instagram", tiktok: "TikTok", youtube: "YouTube" };

export const WORK_CATEGORIES = ["Campaña", "Auspicio", "Lanzamiento", "Evento", "Contenido orgánico", "IRL", "Streaming", "Otro"];
